import Carousel from "bootstrap/js/dist/carousel";
import { createObserver } from "./observer-factory";

// define the observer
const observer = createObserver(0.7);

document.addEventListener("DOMContentLoaded", () => {
  const carousel_rides = document.querySelectorAll(".js-carousel-ride");
  carousel_rides.forEach((carousel) => {
    observer.observe(carousel);
    const /** @type Carousel */ c = Carousel.getOrCreateInstance(carousel);
    carousel.addEventListener('intersecting', () => {
      c.cycle();
    });
    carousel.addEventListener('not-intersecting', () => {
      c.pause();
    });
  });
});
